import axios from "axios";
import Cookies from "js-cookie";

export function parsePercentage(percentStr: string): number {
  return parseFloat(percentStr.replace('%', '')) || 0;
}

export function parseMemoryMB(memStr: string): number {
  const match = memStr.match(/([\d.]+)\s*(GB|MB|KB)?$/i);
  if (!match) return 0;
  
  const value = parseFloat(match[1]);
  const unit = (match[2] || 'MB').toUpperCase();
  
  switch (unit) {
    case 'GB': return value * 1024;
    case 'KB': return value / 1024;
    default: return value; // MB
  }
}

export function parseStorageGB(storageStr: string): number {
  const match = storageStr.match(/([\d.]+)\s*(TB|GB|MB)?$/i);
  if (!match) return 0;
  
  const value = parseFloat(match[1]);
  const unit = (match[2] || 'GB').toUpperCase();
  
  switch (unit) {
    case 'TB': return value * 1024;
    case 'MB': return value / 1024;
    default: return value; // GB
  }
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

export function formatUptime(timestampMs: number): string {
  const now = Date.now();
  const uptimeMs = now - timestampMs;
  const uptimeSeconds = Math.floor(uptimeMs / 1000);
  
  const days = Math.floor(uptimeSeconds / 86400);
  const hours = Math.floor((uptimeSeconds % 86400) / 3600);
  const minutes = Math.floor((uptimeSeconds % 3600) / 60);
  
  if (days > 0) return `${days}d ${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
}

export function getAlertColor(usage: number): 'success' | 'warning' | 'danger' {
  if (usage >= 90) return 'danger';
  if (usage >= 80) return 'warning';
  return 'success';
}

export function getProgressColor(usage: number): string {
  if (usage >= 90) return 'red.500';
  if (usage >= 80) return 'yellow.500';
  return 'green.500';
}

export const getHeadersForRequest = async () => {
    try {
      // const userToken = userToken_test;
      // const emailAddress = emailAddress_test;
      // const deviceId = deviceId_test;
  
      const userToken = await Cookies.get("userToken");
      const emailAddress = await Cookies.get("emailAddress");
      const deviceId = await Cookies.get("deviceId");
      const profile = await Cookies.get("profile");
      const username = await Cookies.get("username");
  
      // console.log({
      //   username: username,
      //   userToken: userToken,
      //   emailAddress: emailAddress,
      //   deviceId: deviceId,
      //   profile: profile,
      // });
  
      if (profile === undefined) {
        if (username === undefined) {
          console.log("Profile null, Username Null");
          return {
            userToken: userToken,
            emailAddress: emailAddress,
            deviceId: deviceId,
          };
        } else {
          console.log("Profile null, Username Not Null");
          return {
            userToken: userToken,
            emailAddress: emailAddress,
            deviceId: deviceId,
            username: username,
          };
        }
      } else if (profile === "main") {
        if (username === undefined) {
          console.log("Profile main, Username Null");
          return {
            userToken: userToken,
            emailAddress: emailAddress,
            deviceId: deviceId,
          };
        } else {
          console.log("Profile null, Username not Null");
          return {
            userToken: userToken,
            emailAddress: emailAddress,
            deviceId: deviceId,
            username: username,
          };
        }
      } else {
        if (username === undefined) {
          // console.log("Profile not null and not main, Username Null");
          return {
            userToken: userToken,
            emailAddress: emailAddress,
            deviceId: deviceId,
            profile: profile,
          };
        } else {
          console.log("Profile not main and not null, Username not Null");
          return {
            userToken: userToken,
            emailAddress: emailAddress,
            deviceId: deviceId,
            username: username,
            profile: profile,
          };
        }
      }
    } catch (error) {
      console.error(error);
    }
  };